import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GroupOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"group_off"}/>
}
